import {Component, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import { BookmarkIconComponent } from 'src/app/core/components/bookmark/bookmark-icon/bookmark-icon.component';
import { UrlService } from 'src/app/core/services/url-service/url.service';
import { StartPageSearchableAppInterface } from 'src/app/core/services/apps-search-service/searchable-app.interface';

@Component({
    selector: 'bookmark-search-result',
    imports: [CommonModule, BookmarkIconComponent],
    templateUrl: './bookmark-search-result.component.html',
    styleUrls: ['./bookmark-search-result.component.scss']
})
export class BookmarkSearchResultComponent {
  bookmark = input.required<StartPageSearchableAppInterface>();

  constructor(private urlService: UrlService) {}

  openAppURL(): void {
    this.urlService.openURL(this.bookmark().bookmarkURL);
  }

  get getBookmarkContainerName(): string {
    const bookmark = this.bookmark();
    const containerName = bookmark.folderName ?? bookmark.collectionName;
    return containerName ? `In „${containerName}”` : bookmark.subtitle ?? '';
  }
}
